export function createPathObjects(paths: (string | string[])[]) {
  const flattenedPaths = paths.flat();
  return flattenedPaths.map((path) => ({ path }));
}
